'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('login', {
      url: '/login',
      template: require('./login/login.html'),
      controller: 'LoginController',
      controllerAs: 'ctrl'
    });
}



// WEBPACK FOOTER //
// ./public/dev/app/account/account.routes.js